/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const GeographicReach = {
  InternationalOnly: "international-only",
  UsAndInternational: "us-and-international",
  UsOnly: "us-only",
} as const;
export type GeographicReach = ClosedEnum<typeof GeographicReach>;

/** @internal */
export const GeographicReach$inboundSchema: z.ZodNativeEnum<
  typeof GeographicReach
> = z.nativeEnum(GeographicReach);
/** @internal */
export const GeographicReach$outboundSchema: z.ZodNativeEnum<
  typeof GeographicReach
> = GeographicReach$inboundSchema;
